import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { getAllYmmd } from "@store/Services/YMMDService";
import { StoreHandlerProps } from "@store/Store/HandlerCreator";
import { GetYMMDApiParameter } from "@store/Types/ApiModels";

interface Props extends StoreHandlerProps {
    apiParameter: GetYMMDApiParameter;
}

type HandlerType = Handler<GetYMMDApiParameter, Props>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const GetAllYmmdAttributes: HandlerType = async props => {
    const results = await getAllYmmd(props.apiParameter);
    props.dispatch({
        type: "Components/RsswYMMD/SetAllParams",
        apiResult: results,
    });
};

export const chain = [PopulateApiParameter, GetAllYmmdAttributes];

const setAllYMMD = createHandlerChainRunner(chain, "GetAllYmmdAttributes");
export default setAllYMMD;
